const LogoutIcon = () => `
<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 12H20M20 12L15.7143 8M20 12L15.7143 16" stroke="currentColor" stroke-width="2"/>
<path d="M13 16.2V19H4V5H13V8.15" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
</svg>`;
export default LogoutIcon;
